import React from "react";

const COLORS = [
  "#E53935", "#D81B60", "#8E24AA", "#5E35B1",
  "#1E88E5", "#039BE5", "#00ACC1", "#00897B",
  "#43A047", "#4bc800", "#C0CA33", "#FB8C00",
  "#F4511E", "#6D4C41", "#546E7A", "#000000",
];

class ColorPicker extends React.Component {
  state = {
    color: this.props.dbColor && this.props.dbColor.charAt(0) === "#"
      ? this.props.dbColor
      : "#E53935",
  };

  handleSelect = (color) => {
    this.setState({ color });
    this.props.onSelectColor(color);
  };

  render() {
    const { color } = this.state;
    return (
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
      }}>
        {COLORS.map((c) => (
          <div
            key={c}
            onClick={() => this.handleSelect(c)}
            title={c}
            style={{
              width: "26px",
              height: "26px",
              borderRadius: "50%",
              background: c,
              cursor: "pointer",
              flexShrink: 0,
              boxShadow: color === c
                ? `0 0 0 2px #fff, 0 0 0 4px ${c}`
                : "0 1px 3px rgba(0,0,0,0.25)",
              transform: color === c ? "scale(1.15)" : "scale(1)",
              transition: "transform 0.15s, box-shadow 0.15s",
            }}
          />
        ))}
      </div>
    );
  }
}

export default ColorPicker;
